import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../core/_config/app.config';
import { AuthServiceCustom } from '../core/auth/authServiceCustom';

@Injectable({
    providedIn: 'root',
})
export class JournalService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig, public authServiceCustom: AuthServiceCustom) {}

    getJournals(options: any): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal`, options);
    }

    GetByIdWithItems(id: any): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal/${id}/journal-and-items`);
    }

    getById(id: any): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal/${id}`);
    }

    getJournalItens(id: any): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal/${id}/Itens`);
    }

    saveJournalIten(id: any): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal/${id}/Itens`);
    }

    CancelDracma(journalId: any): Observable<any> {
        return this.http.put<any>(`${this.API_URL}Journal/CancelDracma/${journalId}`, null);
    }

    updateJournalItem(journalId: any, journalItem: any): Observable<any> {
        return this.http.put<any>(`${this.API_URL}Journal/${journalId}/Item/Update`, journalItem);
    }

    exportJournal(id: any): Observable<any> {
        return this.http.post<any>(`${this.API_URL}Journal/${id}/Export`, {});
    }

    getJournalStatus(): Observable<any[]> {
        return this.http.get<any[]>(`${this.API_URL}Journal/Status`);
    }

    getAccountingMonth(LegalEntityId: string, month: number, year: number): Observable<any> {
        const params: HttpParams = new HttpParams()
            .append('LegalEntityId', LegalEntityId.toString())
            .append('month', month.toString())
            .append('year', year.toString());
        return this.http.get<any>(`${this.API_URL}Journal/GetAccountingMonth`, { params });
    }

    getStatusByJournalId(id: any): Observable<any> {
        return this.http.get<any[]>(`${this.API_URL}Journal/${id}/StatusByJournalId`);
    }

    saveAttachment(journalId: string, files: File[]): Observable<any> {
        const formData = new FormData();

        files.forEach((file) => {
            formData.append('files', file);
        });

        formData.append('journalId', journalId);
        formData.append('username', this.authServiceCustom.userName);
        
        return this.http.post<any>(`${this.API_URL}Journal/Upload`, formData);
    }

    GetAttachments(journalId: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}Journal/${journalId}/GetAttachments`);
    }

    DeleteAttachments(fileId: string): Observable<any> {
        return this.http.delete<any>(`${this.API_URL}Journal/Attachments/${fileId}`);
    }
}
